export default {
  "site.title": "CSSBuy Spreadsheet - Guia Completo 2026",
  "site.description": "O melhor guia de CSSBuy Spreadsheet. Encontre as melhores planilhas, comparações, dicas de envio e tutoriais completos para comprar da China com CSSBuy.",
  "nav.home": "Início",
  "nav.blog": "Blog",
  "nav.about": "Sobre",
  "nav.contact": "Contato",
  "hero.title": "Melhor CSSBuy Spreadsheet 2026",
  "hero.subtitle": "Sua fonte completa para planilhas CSSBuy, guias de compra e comparações. Economize tempo e dinheiro nas suas compras da China.",
  "hero.cta1": "CSSBuy Spreadsheet",
  "hero.cta2": "Comprar Agora",
  "hero.cta_main": "Acessar Site Principal",
  "categories.title": "Categorias de Produtos",
  "categories.subtitle": "Explore todas as categorias disponíveis na nossa planilha CSSBuy",
  "categories.dropdown_placeholder": "Selecione uma categoria...",
  "articles.title": "Artigos e Guias CSSBuy",
  "articles.subtitle": "Aprenda tudo sobre CSSBuy Spreadsheet com nossos guias completos",
  "articles.read_more": "Ler Artigo Completo",
  "seo.section_title": "O que é CSSBuy Spreadsheet?",
  "seo.section_text": "CSSBuy Spreadsheet é uma ferramenta essencial para compradores internacionais que desejam adquirir produtos da China de forma eficiente. Nossa planilha organiza milhares de produtos por categorias, com preços atualizados e links diretos, permitindo que você encontre exatamente o que procura sem perder tempo navegando em sites chineses.",
  "safety.title": "Compras Seguras com CSSBuy",
  "safety.text": "CSSBuy atua como agente intermediário, não como vendedor. Todas as transações passam por verificação de qualidade antes do envio internacional. Recomendamos sempre verificar as avaliações dos vendedores e utilizar os métodos de envio com rastreamento.",
  "footer.rights": "Todos os direitos reservados.",
  "footer.privacy": "Política de Privacidade",
  "footer.terms": "Termos de Uso",
  "footer.disclaimer": "Este site não é afiliado oficialmente ao CSSBuy. Somos um recurso independente de informações.",
  "article.back_home": "Voltar ao Início",
  "article.related": "Artigos Relacionados",
  "category.shoes": "Shoes",
  "category.hoodies_sweaters": "Hoodies/Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants_shorts": "Pants/Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear/Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "OtherStuff"
}